import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { Nav } from 'react-bootstrap';
import { toast } from 'react-toastify';

import NavBarWithToggle from './NavBarWithToggle';
import { Shapes } from '../../models/entities';
import Roles from '../../models/Roles';

class LoggedInNavBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showToggle: false };
    this.onSwitchToggle = this.onSwitchToggle.bind(this);
  }

  componentDidMount() {
    const { onLoad } = this.props;
    onLoad().catch((error) => toast.error(error.message));
  }

  onSwitchToggle() {
    this.setState((before) => ({ showToggle: !before.showToggle }));
  }

  renderMainNav() {
    const { profile } = this.props;
    return (
      <Nav className="mr-auto">
        <LinkContainer exact to="/">
          <Nav.Link onClick={this.onSwitchToggle}>Home</Nav.Link>
        </LinkContainer>
        {profile && Roles.isManager(profile.role) ? (
          <>
            <LinkContainer exact to="/manage/clients">
              <Nav.Link onClick={this.onSwitchToggle}>Clients</Nav.Link>
            </LinkContainer>
            <LinkContainer exact to="/manage/users">
              <Nav.Link onClick={this.onSwitchToggle}>Users</Nav.Link>
            </LinkContainer>
            <LinkContainer exact to="/manage/terminals">
              <Nav.Link onClick={this.onSwitchToggle}>Terminals</Nav.Link>
            </LinkContainer>
            <LinkContainer exact to="/manage/creditCards">
              <Nav.Link onClick={this.onSwitchToggle}>Credit Cards</Nav.Link>
            </LinkContainer>
            <LinkContainer exact to="/manage/achBankInfo">
              <Nav.Link onClick={this.onSwitchToggle}>ACH Bank Info</Nav.Link>
            </LinkContainer>
          </>
        ) : null }
        {profile && (Roles.isManager(profile.role) || Roles.isCustomer(profile.role)) ? (
          <LinkContainer exact to="/payments">
            <Nav.Link onClick={this.onSwitchToggle}>Payments</Nav.Link>
          </LinkContainer>
        ) : null }
      </Nav>
    );
  }

  render() {
    const { showToggle } = this.state;
    const { children } = this.props;
    return (
      <NavBarWithToggle
        showToggle={showToggle}
        onSwitchToggle={this.onSwitchToggle}
      >
        {this.renderMainNav()}
        {children}
      </NavBarWithToggle>
    );
  }
}

LoggedInNavBar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onLoad: PropTypes.func.isRequired,
  profile: Shapes.USER,
};

LoggedInNavBar.defaultProps = {
  profile: null,
  children: undefined,
};

export default LoggedInNavBar;
